import React from 'react';
import classNames from 'classnames/bind';
import { ScrollableProductCards } from '@components';
import { ProductsResponse, CategoryLandingPageProductListSection } from '@services';
import styles from '../CategoryLandingPage.module.scss';

const CN = 'category-landing-page';
const sectionClassName = `${CN}__section`;
const cx = classNames.bind(styles);

interface Props {
  section: CategoryLandingPageProductListSection;
  products: ProductsResponse
}

export const ProductList: React.FC<Props> = ({
  section: {
    product_list: {
      title
    }
  },
  products
}) => (
  <div className={ cx(sectionClassName) }>
    <ScrollableProductCards
      products={ products }
      title={ title }
      analyticsContext={ {
        listId: `category-product-list-${title}`,
        listName: `Category Product List - ${title}`
      } }
    />
  </div>
);
